import { render } from "./HeroiconsOutlineOfficeBuilding.vue?vue&type=template&id=2e2f5a88"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineOfficeBuilding.vue"]])

export default __exports__